<template>
    <div class="picture-quality-error">
        <img
            class="picture-quality-img"
            src="@/assets/warning.svg"
            alt="warning"
        />
        <p class="picture-quality-text t-bold">
            {{ hasError.get('documentImage') }}
        </p>
    </div>
</template>

<script lang="ts">
import { mapState } from 'vuex';
export default {
    props: {
        front: Boolean,
    },
    computed: {
        ...mapState({
            hasError: (state: any) => state.errors,
        }),
    },
};
</script>
